import React, { ComponentProps } from "react";
import { ButtonLink, PlusLink } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
import { Image } from "@wss/image";
import RecommendedItemData from "../../contracts/RecommendedItem";
import Skeleton from "../../../Skeleton";
const RecommendedItemSkeleton = () => <div className="flex flex-col items-center" data-testid="skeleton-item" data-sentry-component="RecommendedItemSkeleton" data-sentry-source-file="RecommendedItem.tsx">
    <div className="border border-solid border-[#f1f1f1] rounded-md shadow-[0_1px_2px_rgba(0,0,0,0.05)] mb-[13px] p-2">
      <Skeleton className={cls("w-[105px] h-[105px]", "xxl:w-[109px] xxl:h-[109px]", "xxxsl:w-[134px] xxxsl:h-[134px]")} data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
    </div>
    <Skeleton className="w-[125px] h-3" data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
    <Skeleton className="w-[125px] h-3 mt-1" data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
    <Skeleton className="w-[125px] h-4 mt-1-1/2" data-sentry-element="Skeleton" data-sentry-source-file="RecommendedItem.tsx" />
  </div>;
interface RecommendedItemProps extends RecommendedItemData {
  loading?: boolean;
}
const RecommendedItem = ({
  loading = true,
  className,
  link,
  description,
  imagePath,
  altText = "",
  price,
  unitOfMeasure,
  isWebstaurantPlusEligible = false,
  ...rest
}: RecommendedItemProps & ComponentProps<"div">) => {
  return loading && <RecommendedItemSkeleton /> || <ButtonLink theme="wss" href={link} variant="plain" color="green" className="h-auto no-underline outline-none" data-testid={`recommended-item-${description}`}>
        <div className={cls("flex flex-col space-y-1 items-center", className)} {...rest}>
          <div className={cls("relative overflow-hidden", "max-w-[105px] max-h-[105px] rounded-md border border-solid border-[#f1f1f1] shadow-[0_1px_2px_rgba(0,0,0,0.05)] mb-[13px] p-2", "xxl:max-w-[109px] xxl:max-h-[109px]", "xxxsl:max-w-[134px] xxxsl:max-h-[134px]")}>
            {isWebstaurantPlusEligible && <PlusLink cutoff={true} className="absolute left-0" data-testid={`plus-link-${description}`} />}

            <Image src={imagePath} alt={altText} className="w-full h-full" height={105} width={105} />
          </div>
          <div className="text-[13px] leading-[14px] text-center max-w-[125px] max-h-[28px] text-wrap line-clamp-2 text-ellipsis">
            {description}
          </div>
          <div className="flex flex-row items-baseline">
            <span className="text-lg leading-5 font-bold text-red-500">
              ${price}
            </span>
            <span className="text-2xs leading-3 font-semibold text-gray-900">
              /{unitOfMeasure}
            </span>
          </div>
        </div>
      </ButtonLink>;
};
export default RecommendedItem;